import type {RouteRecordRaw} from 'vue-router';
import {useCsvImport} from '@myparcel-frontend/csv-import';
import {useServiceAccount} from '@/composables/useServiceAccount/useServiceAccount';

export const productRoutes: RouteRecordRaw[] = [
  {
    path: '/products',
    beforeEnter: [
      () => {
        const {isProductsAccessible} = useServiceAccount();

        if (!isProductsAccessible.value) {
          return {name: 'dashboard'};
        }

        return true;
      },
    ],
    children: [
      {
        name: 'products',
        path: '',
        component: () => import('@/views/Products/ProductOverview.vue'),
        meta: {
          title: (t) => t('products.product', 2),
        },
      },
      {
        name: 'products-import',
        path: 'import',
        component: () => import('@/views/Products/ProductsImport/ProductsImport.vue'),
        redirect: {
          name: 'products-import-overview',
        },
        children: [
          {
            name: 'products-import-overview',
            path: '',
            components: {
              productsImport: () =>
                import('@/views/Products/ProductsImport/ProductsImportOverview/ProductsImportOverview.vue'),
            },
            meta: {
              title: (t) => t('products.manualImport'),
            },
          },
          {
            name: 'products-import-edit',
            path: 'edit',
            beforeEnter: () => {
              const {csvFile} = useCsvImport();

              if (!csvFile.value) {
                return {name: 'products-import-overview'};
              }

              return true;
            },
            components: {
              productsImport: () => import('@/views/Products/ProductsImport/ProductsImportEdit/ProductsImportEdit.vue'),
            },
            meta: {
              title: (t) => t('products.manualImport'),
            },
          },
        ],
      },
      {
        name: 'products-new',
        path: 'new',
        component: () => import('@/views/Products/NewProduct.vue'),
        meta: {
          title: (t) => t('products.new'),
        },
      },
      {
        name: 'products-edit',
        path: ':productId',
        props: true,
        component: () => import('@/views/Products/EditProduct.vue'),
        meta: {
          title: (t) => t('products.edit'),
        },
      },
    ],
  },
];
